<template>
  <div>
    <h1>Change Ownership</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- Change Ownership By Vehicle Category Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">Change Ownership By Vehicle Category</h5>
      <change-ownership-by-vehicle-category
        :filterUrl="filterUrl"
      ></change-ownership-by-vehicle-category>
    </div>
    <!-- Change Ownership By Vehicle Category End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import changeOwnershipByVehicleCategory from './children/changeOwnershipByVehicleCategory'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      changeOwnershipByVehicleCategory,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>